import indexMixin from "../mixins/index";
export default {
  name: "res-steps",
  mixins: [indexMixin],

  data() {
    return {};
  },

  props: {
    active: {
      type: Number,
      default: 0
    },
    stepOptions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    valueToLabel() {
      return this.stepOptions[this.active].title || '';
    },

    getComAttr() {
      if (this.$attrs.direction === 'horizontal') {
        return { ...this.$attrs,
          space: null
        };
      }

      return this.$attrs;
    }

  }
};